import { get, patch, post } from './service'

const dispatchBundleNavigationEvent = (eventName) => {
  try {
    window.dispatchEvent(new CustomEvent(eventName))
  } catch (_error) {
    // Never block publish/save flow if browser event APIs fail.
  }
}

const mapProduct = (product) => {
  return ({
    id: product.turbosquid_id,
    name: product.name,
    thumbnail: product.thumbnail_path,
    price: product.price,
    license_id: product.license_id,
  })
}

const mapProductFromId = (product) => {
  return ({
    id: product.data[0].turbosquid_id,
    name: product.data[0].name,
    thumbnail: product.data[0].thumbnail_path,
    price: product.data[0].price,
  })
}

const parsePrice = (value, denominator, currency) => {
  const amount = value / denominator
  const options = { style: 'currency', currency: currency }
  const formattedAmount = new Intl.NumberFormat('en-US', options).format(amount)

  return formattedAmount.toString()
}

const mapProducts = (products) => {
  return products.filter((p) => (!p.bundle))
    .filter((p) => (!p.feature_assignments.some((f) => f.name === 'Collection')))
    .filter((p) => (p.license_id !== 7))
    .map(mapProduct)
}

export async function getProduct({ id, csrfToken }) {
  const url = `/turbosquid/products?turbosquid_ids=${id}`
  const resp = await get(url, { authenticity_token: csrfToken })
  return resp ? mapProductFromId(resp) : null
}

export async function getProducts({ ids, searchTerm, csrfToken }) {
  const url = `/turbosquid/products?size=200&term=${searchTerm}`
  const resp = await get(url, { authenticity_token: csrfToken })
  return resp?.data ? mapProducts(resp.data) : []
}

export async function getProductsWithIds({ ids, csrfToken }) {
  const url = `/turbosquid/products?turbosquid_ids=${ids}`
  const resp = await get(url, { authenticity_token: csrfToken })

  return resp.data.reduce((acc, product) => {
    return ({
      ...acc,
      [product.turbosquid_id]: mapProduct(product),
    })
  }, {})
}

const publishBundleRequest = async (url, csrfToken, options) => {
  try {
    const response = await window.fetch(url, {
      method: 'PATCH',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        authenticity_token: csrfToken,
        turbosquid_product_form: options,
        publish: true,
      }),
    })

    if (!response.ok) return null

    const contentType = response.headers.get('Content-Type') || response.headers.get('content-type') || ''
    if (!contentType.toLowerCase().includes('application/json')) return null

    const payload = await response.json().catch(() => ({}))
    return payload?.data ?? payload ?? {}
  } catch (_error) {
    return null
  }
}

export async function publishBundleProduct(options, csrfToken, publish) {
  const url = '/turbosquid/products/0'
  let resp = null
  try {
    if (publish) {
      resp = await publishBundleRequest(url, csrfToken, options)
    } else {
      resp = await patch(url, { authenticity_token: csrfToken, turbosquid_product_form: options })
    }
  } catch (_error) {
    resp = null
  }
  const data = resp ?? null

  if (publish && data !== null) {
    dispatchBundleNavigationEvent('bundle:allow-navigation')
    window.location.href = gon.turbosquid_products_path
  } else if (publish) {
    dispatchBundleNavigationEvent('bundle:reset-navigation')
  }

  return data
}
